import angular from 'angular';
import guid from '@/shared/utils/guid';
import { getCreditNoteReasons } from '@/shared/services/CreditNoteReasonService';

angular.module('cloudX').directive('cxCreditNoteReasonPicker', [
  '$filter',
  '$q',
  function($filter, $q) {
    return {
      restrict: 'E',
      replace: true,
      scope: true,
      template: `<div>
        <tags-input
          ng-model="selected"
          placeholder="{{('CreditNoteReason'|translate)}}"
          display-property="name"
          key-property="id"
          on-tag-added="updateValue()"
          on-tag-removed="updateValue()"
          replace-spaces-with-dashes="false"
          add-from-autocomplete-only="true"
          min-length="1"
          tag-class="addCssClass($tag)"
          class="bootstrap">
          <auto-complete
            source="getSuggestions($query)"
            load-on-focus="true"
            load-on-empty="true"
            display-property="name"
            match-class="addCssClass($match)"
            max-results-to-show="25"
            min-length="0">
          </auto-complete>
        </tags-input>

      </div>`,
      require: 'ngModel',
      link: function($scope, el, attrs, ngModel) {
        if (!ngModel) return;

        $scope.selected = [];
        $scope.allOptions = [];
        $scope.loaded = false;
        $scope.tmpValue = null;

        // Every reason is kept in allOptions, disabled ones included, so a reason that was
        // disabled after it got selected still resolves into a tag. Disabled reasons stay out
        // of the default suggestion list, but searching by name still finds them.
        var findOption = function(id) {
          if (id == null || $scope.allOptions.length === 0) return null;
          return $scope.allOptions.find(function(el) {
            return el.id === id;
          });
        };

        var filterOptions = function(search) {
          if (!search) {
            return $scope.allOptions.filter(function(option) {
              return !option.disabled;
            });
          }
          return $filter('filter')($scope.allOptions, { name: search });
        };

        var loadReasons = function() {
          return $q.when(getCreditNoteReasons()).then(function(reasons) {
            $scope.allOptions = (reasons || []).map(function(reason) {
              return { id: reason.id, name: reason.name, disabled: reason.disabled };
            });
            $scope.allOptions.unshift({
              id: guid.empty,
              name: $filter('translate')('WithoutCreditNoteReason'),
              disabled: false,
            });
            if ($scope.tmpValue) {
              $scope.selected = $scope.tmpValue.map(findOption).filter(Boolean);
              $scope.tmpValue = null;
            }
            $scope.loaded = true;
          });
        };

        $scope.getSuggestions = function(search) {
          if (!$scope.loaded)
            return loadReasons().then(function() {
              return filterOptions(search);
            });
          return filterOptions(search);
        };

        $scope.updateValue = function() {
          ngModel.$setViewValue(
            $scope.selected.map(function(x) {
              return x.id;
            }),
          );
        };
        $scope.addCssClass = function(item) {
          return item.disabled ? 'strike' : '';
        };

        ngModel.$render = function() {
          var value = ngModel.$viewValue;
          if (value !== null && typeof value !== 'undefined' && angular.isArray(value)) {
            if (!$scope.loaded) {
              $scope.tmpValue = value;
            } else {
              $scope.selected = value.map(findOption).filter(Boolean);
            }
          }
        };

        // Loaded up front, not on first focus: a filter restored from sessionStorage has to
        // render its tags without waiting for the user to open the suggestion list.
        loadReasons();
      },
    };
  },
]);
